export default "__VITE_ASSET__Bht8yu86__"